import { useEffect, useRef, useState } from 'react';
import lottie, { AnimationItem } from 'lottie-web';
import animationData from '../../../assets/lottie/pie-timer.json';
import { Grid2 } from '@mui/material';
import theme, { TMaterialStyles } from '../../theme';
import TypographyWithShadow from '../Typography/TypographyWithShadow';

interface IPieTimer {
  timer?: string | null;
  isTimerDisabled: boolean;
}

const PieTimer = ({ timer, isTimerDisabled }: IPieTimer) => {
  const animationRef = useRef<HTMLDivElement | null>(null);
  const animationInstance = useRef<AnimationItem | null>(null);
  const [initialSpeed, setInitialSpeed] = useState<number | null>(null);

  useEffect(() => {
    if (timer && initialSpeed === null) {
      setInitialSpeed(Number(timer));
    }
  }, [timer, initialSpeed]);

  useEffect(() => {
    if (!animationRef.current || initialSpeed === null) return;

    animationInstance.current = lottie.loadAnimation({
      container: animationRef.current,
      renderer: 'svg',
      autoplay: true,
      loop: false,
      animationData: animationData,
    });

    animationInstance.current.setSpeed(1 / initialSpeed);

    return () => {
      animationInstance.current?.destroy();
    };
  }, [initialSpeed]);

  useEffect(() => {
    if (animationInstance.current) {
      if (isTimerDisabled) {
        animationInstance.current.pause();
      } else {
        animationInstance.current.goToAndPlay(0, true);
      }
    }
  }, [isTimerDisabled]);

  return (
    <>
      <Grid2 sx={materialStyles.borderBlock} />

      <Grid2 sx={materialStyles.container}>
        <Grid2 ref={animationRef} sx={materialStyles.timer} />
        <TypographyWithShadow shadowType="DARK" sx={materialStyles.timerText}>
          {timer || '0'}
        </TypographyWithShadow>
      </Grid2>
    </>
  );
};

const materialStyles: TMaterialStyles = {
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '118px',
    height: '118px',
    background: `${theme.palette.primary.main}`,
    borderRadius: '100%',
    boxShadow: `0px 3px 0px 0px ${theme.palette.primary.dark}`,
  },
  borderBlock: {
    width: '120px',
    height: '120px',
    border: '8px solid #fff',
    display: 'block',
    position: 'absolute',
    zIndex: 1,
    borderRadius: '100%',
    boxShadow: `inset 0px 3px 0px ${theme.palette.primary.dark}`,
  },
  timer: {
    width: '120px',
    height: '120px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  timerText: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontFamily: 'Rubber Duck !important',
    fontSize: '50px',
    fontWeight: 'bold',
    color: '#fff',
  },
};

export default PieTimer;
